function ErrorPage() {
    return <h1>Ocorreu um erro inesperado</h1>;
}
  
export default ErrorPage;